
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nba/draft/[year]/draft-history/draft-by-year",
      function () {
        return require("private-next-pages/nba/draft/[year]/draft-history/draft-by-year/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nba/draft/[year]/draft-history/draft-by-year"])
      });
    }
  